
import { Component, input } from '@angular/core';
import{CardModule} from 'primeng/card'
@Component({
  selector: 'app-card-item',
  imports: [CardModule],
  templateUrl: './card-item.component.html',
  styleUrl: './card-item.component.css'
})
export class CardItemComponent {
  cardItem = input<any>();

}
